import Vue from 'vue';
import router from './router';
import store from './store';

// Import root components
import App from './App.vue';

// Plugins
import i18n from './plugins/i18n';
import vuetify from './plugins/vuetify';
import './plugins/vee-validate';
import './plugins/highcharts';
import './plugins/money';
import './plugins/export';
import podocore from './plugins/podolib';

// Layouts
import LayoutDefault from './layouts/Default.vue';
import LayoutAuth from './layouts/Auth.vue';
import LayoutAuthTrial from './layouts/AuthTrial.vue';
import LayoutDashboard from './layouts/Dashboard.vue';
import LayoutAnalysis from './layouts/LayoutAnalysis.vue';

// Base components
import BaseAlert from './components/base/BaseAlert.vue';
import BaseWarn from './components/base/BaseWarn.vue';
import BaseSuccess from '@/components/base/BaseSuccess.vue';
import BaseInfo from '@/components/base/BaseInfo.vue';

// Inject layouts
Vue.component('LayoutDefault', LayoutDefault);
Vue.component('LayoutAuth', LayoutAuth);
Vue.component('LayoutAuthTrial', LayoutAuthTrial);
Vue.component('LayoutDashboard', LayoutDashboard);
Vue.component('LayoutAnalysis', LayoutAnalysis);

// Inject base components
Vue.component('BaseAlert', BaseAlert);
Vue.component('BaseWarn', BaseWarn);
Vue.component('BaseSuccess', BaseSuccess);
Vue.component('BaseInfo', BaseInfo);

export const init = async () => {
  // Podocore
  await podocore.init(Vue, store);
  // Create app
  return new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
};
